import './polyfills' // This import needs to come first

import React from 'react'
// import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import { I18nContext, I18nManager } from '@shopify/react-i18n'
// import registerServiceWorker from './registerServiceWorker'
import { Provider } from 'react-redux'
import '@nosferatu500/react-sortable-tree/style.css'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import configureStore from '@sportninja/common/store'
import rootSagaCreator from '@sportninja/common/sagas'
import rootReducer from '@sportninja/common/reducers'
import { ThemeProvider } from './configs'

import history from './history'
import App from './pages/App'

// This must come before App component import. These are the base imports that are
// overridden by component-specific styles that get imported via <App />
import './utility.scss'
import './index.scss'

const locale = 'en'
const i18nManager = new I18nManager({
  locale,
  onError(error) {
    console.log(error)
  },
})

const packageJson = require('./../package.json')
const version = packageJson.version

Sentry.init({
  // eslint-disable-next-line no-undef
  enabled: __DEV__ ? false : true,
  // eslint-disable-next-line no-undef
  environment: __DEV__ ? 'development' : 'production',
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
  release: version,
})

const store = configureStore(rootReducer, rootSagaCreator(), history)

// ReactDOM.render(
//   <Provider store={store}>
//     <App history={history} />
//   </Provider>,
//   document.getElementById('root')
// )

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <ThemeProvider>
      <I18nContext.Provider value={i18nManager}>
        <App history={history} />
      </I18nContext.Provider>
    </ThemeProvider>
  </Provider>
)

// Just a pain.
// registerServiceWorker()
